export const GET_PROJECTS = 'GET_PROJECTS';
